<div class="a-dialog-container" [style.width]="config.width" [style.maxWidth]="config.maxWidth||''"
    [style.minWidth]="config.minWidth||''" [style.height]="config.height" [style.maxHeight]="config.maxHeight||''" [style.minHeight]="config.minHeight||''">
    <div class="a-dialog-header" *ngIf="showHeader">
        <span class="a-dialog-header-title tell">{{config.title}}</span>
        <span class="a-dialog-action-container" *ngIf="config.canClose">
            <span class="a-dialog-action-close" (click)="closeDialog()"><i class="fa fa-times"></i></span>
        </span>
    </div>
    <div class="a-dialog-content">
        <ng-container *ngIf="config.templateRef">
            <div *ngTemplateOutlet="config.templateRef;context:{data:templateRefContext};"></div>
        </ng-container>
        <ng-template #host></ng-template>
    </div>
</div>